import {IconButton} from '@wandb/components';
import React from 'react';

// This menu appears when you make a selection in a Parallel Coordinates or Scatter Plot
// Menu options: Clear selection, or Convert selection to filters
export const SelectionBoundsMenu: React.FC<{
  clearSelections(): void;
  convertSelectionsToFilters(): void;
}> = ({clearSelections, convertSelectionsToFilters}) => {
  const clearButton = (
    <IconButton
      icon="close"
      size="sm"
      variant="secondary"
      aria-label="Clear selection"
      tooltip={{children: 'Clear selection'}}
      onPress={clearSelections}
    />
  );
  if (convertSelectionsToFilters == null) {
    return clearButton;
  }
  return (
    <div className="flex items-center gap-4">
      <IconButton
        icon="filter-alt"
        size="sm"
        variant="secondary"
        aria-label="Create a filter from this selection"
        tooltip={{children: 'Create a filter from this selection'}}
        onPress={convertSelectionsToFilters}
      />
      {clearButton}
    </div>
  );
};
